module.exports = __webpack_public_path__ + "img/sh.66ef2b30.svg";